// Utility functions for Firebase initialization checks

/**
 * Determines if Firebase should be initialized based on the current route
 * @returns {boolean} True if Firebase should be initialized, false otherwise
 */
export const shouldInitializeFirebase = (): boolean => {
  // Check if we're on the shareable company profile route
  const currentPath = window.location.pathname;
  
  // Routes that should NOT initialize Firebase
  const excludedRoutes = [
    '/company-profile/shareable',
    // Add other routes here if needed in the future
  ];
  
  const isExcludedRoute = excludedRoutes.some(route => currentPath.includes(route));
  
  // Don't initialize Firebase for excluded routes or in webview environments
  if (isExcludedRoute) {
    console.log(`Skipping Firebase initialization for route: ${currentPath}`);
    return false;
  }
  
  return true;
};

/**
 * Checks if the current route is a shareable route
 * @returns {boolean} True if current route is shareable
 */
export const isShareableRoute = (): boolean => {
  const currentPath = window.location.pathname;
  return currentPath.includes('/company-profile/shareable');
}; 